import { backgroundColor, blackColors, hexToRgb, dangerColor } from 'assets/jss/material-dashboard-pro-react';

const settingsSubpageStyle = (theme) => ({
	cardBasicStyle: {
		display: 'flex',
		flexDirection: 'row',
		marginTop: 0,
	},
	pinPukCardsContainer: {
		justifyContent: 'center',
		display: 'flex',
		flexDirection: 'row',
		[theme.breakpoints.down('xs')]: {
			flexDirection: 'column',
		},
	},
	pinPukCard: {
		position: 'relative',
		display: 'flex',
		justifyContent: 'center',
		'& > div': {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'flex-end',
			position: 'relative',
			marginTop: '14px',
			zIndex: 1,
			marginBottom: '170px',
			minWidth: '34%',
			[theme.breakpoints.down('xs')]: {
				marginTop: '10px',
				marginBottom: '148px',
			},
			'& div': {
				display: 'flex',
				flexDirection: 'row',
				'& p': {
					marginBottom: '2px',
					lineHeight: 1.33,
					'&:first-of-type': {
						minWidth: '50px',
						textTransform: 'uppercase',
					},
				},
				'&:last-of-type': {
					'& p': {
						marginBottom: 0,
					},
				},
			},
		},
		'& img': {
			position: 'absolute',
			width: '333px',
			height: 'auto',
			left: '50%',
			transform: 'translateX(-50%)',
			maxWidth: '94%',
			top: 5,
		},
		'& .btnContainer': {
			position: 'absolute',
			top: '50%',
			left: '33%',
			transition: 'all .3s ease-in-out',
			opacity: 0,
			[theme.breakpoints.only('sm')]: {
				left: '50%',
				transform: 'translate(-50%, -50%)',
				top: '50%',
			},
		},
	},
	singleCardWrapper: {
		position: 'relative',
		marginBottom: 24,
		'&:hover': {
			'& > div:first-of-type': {
				opacity: 1,
			},
			'& > div:last-of-type': {
				opacity: 1,
			},
		},
	},
	inputWrapper: {
		maxWidth: '228px',
		margin: '0 auto',
		marginBottom: '35px',
		[theme.breakpoints.down('xs')]: {
			marginTop: '-30px',
		},
	},
	numberInfo: {
		padding: '20px 0 28px 0',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'center',
		'& svg': {
			fontSize: '64px',
			color: blackColors[5],
			marginRight: '8px',
		},
		'& div': {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			marginLeft: '8px',
			'& p': {
				marginBottom: 0,
			},
		},
	},
	simReplacementImage: {
		display: 'block',
		margin: '0 auto',
	},
	confirmationDialogBody: {
		'& p': {
			'&:first-of-type': {
				marginBottom: '15px',
			},
			'&:last-of-type': {
				marginBottom: 0,
			},
		},
	},
	tryAgainSection: {
		marginTop: '97px',
		[theme.breakpoints.down('sm')]: {
			marginTop: '30px',
		},
	},
	changeAdslPasswordDialog: {
		maxWidth: 312,
		margin: '40px auto 80px',
	},
	resetAdslPasswordDialog: {
		marginTop: 32,
	},
	resetAdslPasswordTab: {
		maxWidth: 312,
		margin: '0 auto',
		marginTop: 20,
		marginBottom: 50,
	},
	oldPasswordWrapper: {
		marginBottom: 20,
	},
	rulesWrapper: {
		marginBottom: 10,
	},
	otpTabWrapper: {
		maxWidth: 312,
		margin: '20px auto 0',
		minHeight: 230,
	},
	otpTabWrapperWithLineInput: {
		maxWidth: 312,
		margin: '20px auto 0',
	},
	resendText: {
		marginTop: '0',
	},
	errorBoxWrapper: {
		marginTop: 25,
	},
	circularProgressContainer: {
		position: 'absolute',
		zIndex: 2,
		height: '83%',
		width: '100%',
		borderRadius: 8,
		'& > div': {
			height: '83%',
		},
	},
	resultDataContainer: {
		margin: '15px 60px',
		'& .qrContainer': {
			display: 'flex',
			padding: '20px 0 0 0',
			flexDirection: 'row',
			justifyContent: 'center',
			textAlign: 'center',

			'& img': {
				boxShadow: '0 6px 10px -6px rgb(0 0 0 / 50%)',
			},
		},
	},
	formButtonContainer: {
		textAlign: 'right',
		paddingTop: 27,
	},
	successBoxWrapper: {
		maxWidth: 275,
		margin: '10px auto 0 auto',
		textAlign: 'center',
	},
	loaderWrapper: {
		position: 'absolute',
		width: '100%',
		left: 0,
		height: '100%',
		alignItems: 'center',
		justifyContent: 'center',
		paddingTop: '100px',
		backgroundColor: `rgba(${hexToRgb(backgroundColor[0])}, 0.55)`,
	},
	dataSawaCardWrapper: {
		display: 'flex',
		flexDirection: 'column',
		minHeight: 375,
		justifyContent: 'space-between',
		alignItems: 'center',
		marginBottom: 30,
	},
	dataSawaCard: {
		position: 'relative',
		width: '100%',
		zIndex: 5,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		'& > div': {
			display: 'flex',
			flexDirection: 'row',
			width: 218,
			'& p': {
				marginBottom: 0,
				'&:first-of-type': {
					minWidth: '50px',
					textTransform: 'uppercase',
				},
			},
			'&:last-of-type': {
				'& p': {
					marginBottom: 0,
				},
			},
			'&:first-of-type': {
				paddingTop: 8,
			},
		},
	},
	dataSawaSimImg: {
		position: 'absolute',
		zIndex: -1,
		left: '50%',
		transform: 'translateX(-50%)',
		width: 333,
		height: 'auto',
		maxWidth: '94%',
	},
	deleteButtonWrapper: {
		position: 'absolute',
		zIndex: 6,
		left: 'calc(50% + 100px)',
		top: 8,
	},
	replaceCardButtonWrapper: {
		textAlign: 'center',
	},
	addSimCardWrapper: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		padding: '30px 0',
	},
	simDialogWrapper: {
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'center',
		'& > div': {
			width: '100%',
			'&:first-of-type': {
				width: '100%',
			},
		},
		[theme.breakpoints.down('sm')]: {
			flexDirection: 'column',
			'& > div': {
				width: '100%',
			},
		},
	},
	simDialogWrapperWithOneCard: {
		'& > div': {
			width: '50%',
			[theme.breakpoints.down('sm')]: {
				width: '100%',
			},
		},
	},
	circularProgressWrapper: {
		width: '100%',
		minHeight: 375,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	otpWrapper: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
	},
	simAlert: {
		display: 'flex',
		alignItems: 'start',
		padding: '12px',
		backgroundColor: backgroundColor[1],
		color: dangerColor[8],
		borderRadius: theme.spacing(1),
		lineHeight: '20px',
	},
	simAlertTitle: {
		fontFamily: theme.fontFamily.albert.bold,
	},
	icon: {
		marginRight: theme.spacing(2),
	},
	otp_note: {
		marginTop: '30px',
	},
});

export default settingsSubpageStyle;
